import React, {Component} from 'react';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import {renderInput, renderTextArea} from "../../forms/newcaso/Fields";
import { updateUser } from '../../../actions/';
import { startLoading, endLoading } from '../../../actions/loadingActions';

class ModalChangeUserData extends Component{
    onSubmit(data){
        this.props.action(data, data.id);
        this.props.startLoading();
        this.props.toggler();
    }

    render(){
        const { handleSubmit } = this.props;
        return(
            <Modal className="modal-dialog-centered" isOpen={this.props.isOpen} toggle={this.props.toggler}>
                <ModalHeader toggle={this.props.toggler}>{this.props.title}</ModalHeader>
                <ModalBody>
                    <p>{this.props.message}</p>
                    <form ref="formChangeUserData" className="modal-form" onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                        <div className="form-row">
                            <Field
                                name="num_colegiado"
                                col="col-md-6"
                                label="Número de colegiado"
                                component={renderInput}
                            />
                            <Field
                                name="phone"
                                col="col-md-6"
                                label="Teléfono"
                                component={renderInput}
                            />
                            <Field
                                name="name"
                                col="col-md-12"
                                label="Nombre"
                                component={renderInput}
                            />
                            <Field
                                name="email"
                                col="col-md-12"
                                label="Email"
                                component={renderInput}
                            />
                        </div>
                    </form>
                </ModalBody>
                <ModalFooter>
                    <Button color="link" onClick={this.props.toggler}>Cancelar</Button>
                    <Button color="primary" onClick={handleSubmit(this.onSubmit.bind(this))}>{this.props.button}</Button>{' '}
                </ModalFooter>
            </Modal>
        )
    }
}
const mapStateToProps = (state, ownProps) => {
    return {
        loading: state.loading,
        initialValues: ownProps.client
    };
}


ModalChangeUserData = reduxForm({
    form: 'formChangeUserData',
    enableReinitialize: true,
})(ModalChangeUserData);



export default ModalChangeUserData = connect(mapStateToProps, {
    updateUser,
    startLoading,
    endLoading
})(ModalChangeUserData);


// WEBPACK FOOTER //
// ./resources/assets/js/components/admin/clients/ModalChangeUserData.jsx